import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { columnParForDates, filterParams } from "../../grid/GridHelpers";
import ActionButton from "../../ActionButton/ActionButton";
import { OrderOffSiteGrid } from "src/app/types/orders/offSite";
import { startCase } from "lodash";
import { KTSVG } from "src/_metronic/helpers/components/KTSVG";
import { TActionData } from "./useSiteAnalyzeOffSiteGridColumns";
import CellTags from "../../grid/CellRenderer/CellTags/CellTags";
import { indexColumn, linksColumn } from "src/app/utils/aggrid/ColumnsStyles";

export default function offSiteGridNLColumns(
    formatMessage: any,
    actions: TActionData
): Array<SimpleEntityGridColumn> {
    return [
        {
            field: "id",
            filter: "agSetColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "publishedAt",
            ...columnParForDates("publishedAt"),
            headerName: formatMessage({ id: "content.grid.col.publishedAt" }),
            filterParams,
            minWidth: 90,
            maxWidth: 90,
        },
        {
            field: "url",
            headerName: formatMessage({ id: "content.grid.col.url" }),
        },
        {
            field: "nl",
            headerName: formatMessage({ id: "content.grid.col.nl" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "silo",
            headerName: formatMessage({ id: "content.grid.col.silos" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "writingType",
            headerName: formatMessage({ id: "urls.grid.col.writingType" }),
            valueGetter: ({ data }: any) =>
                formatMessage({
                    id: `content.grid.col.writingType.${data.writingType}`,
                }),
            filter: "agSetColumnFilter",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "wordCount",
            headerName: formatMessage({ id: "content.grid.col.wordCount" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "keyword",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => data?.keywords,
            cellRenderer: ({ data }: any) => <CellTags tags={data?.keywords} />,
        },
        {
            field: "links",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.links" }),
            ...linksColumn(),
        },
        {
            field: "indexed",
            minWidth: 80,
            maxWidth: 80,
            headerName: formatMessage({ id: "content.grid.col.indexed" }),
            ...indexColumn(),
        },
        {
            field: "indexedAt",
            headerName: formatMessage({ id: "content.grid.col.indexedAt" }),
            ...columnParForDates("indexedAt"),
            filterParams: {
                suppressAndOrCondition: true,
                filterOptions: ["equals", "greaterThanOrEqual", "lessThanOrEqual"],
            },
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "kd",
            headerName: formatMessage({ id: "content.grid.col.kd" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "volume",
            headerName: formatMessage({ id: "content.grid.col.volume" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "actions",
            minWidth: actions.width,
            maxWidth: actions.width,
            cellRenderer: ({ data }: { data: OrderOffSiteGrid }) => {
                return (
                    <>
                        {actions.actions.map((action, index) => (
                            <ActionButton
                                key={index}
                                actions={actions.actives}
                                name={action.name}
                                data={data}
                            >
                                <a
                                    onClick={() => actions.handleActionModals(action.name, data)}
                                    title={startCase(
                                        formatMessage({ id: `common.action.${action.name}` })
                                    )}
                                    className="inline-action"
                                >
                                    <KTSVG path={action.icon} className="svg-icon-2" />
                                </a>
                            </ActionButton>
                        ))}
                    </>
                );
            },
        },
    ];
}
